import {
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
} from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  side: "left" | "right";
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
};

export function PatientProfilePanelToggle({
  side,
  isOpen,
  onToggle,
  className,
}: Props) {
  const Icon =
    side === "left"
      ? isOpen
        ? PanelLeftClose
        : PanelLeftOpen
      : isOpen
        ? PanelRightClose
        : PanelRightOpen;

  const label =
    side === "left"
      ? isOpen
        ? "Collapse patient info"
        : "Expand patient info"
      : isOpen
        ? "Collapse internal notes"
        : "Expand internal notes";

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-expanded={isOpen}
      title={label}
      className={cn(
        "absolute top-1/2 z-50 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full",
        "border border-[#D1D5DB] bg-white text-[#4B5563] shadow-[0_2px_8px_rgba(15,23,42,0.12)] ring-2 ring-primary",
        "transition-all duration-800 hover:border-[#9CA3AF] hover:bg-[#FAFAFA] hover:text-foreground hover:shadow-[0_4px_12px_rgba(15,23,42,0.16)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2",
        side === "left" ? "left-0 -translate-x-1/2" : "right-0 translate-x-1/2",
        !isOpen && "h-12 w-12",
        className,
      )}
    >
      <Icon className={`${isOpen ? "h-4 w-4" : "h-6 w-6"} text-primary shrink-0`} strokeWidth={2} />
    </button>
  );
}
